export enum BatchWriteOffStatus {
  PendingConfirmation = 1,
  Confirmed = 2,
  Reversed = 3,
}

export enum BatchWriteOffSource {
  Manual = 1,
  OrderFulfillmentShortage = 2,
}

export enum BatchWriteOffReason {
  BalanceDiscrepancy = 1,
  Waste = 2,
  ShrinkageExpense = 3,
  WriteOff = 4,
  Expiry = 5,
  OrderFulfillmentShortage = 6,
}

export const MANUAL_BATCH_WRITE_OFF_REASONS = [
  BatchWriteOffReason.BalanceDiscrepancy,
  BatchWriteOffReason.Waste,
  BatchWriteOffReason.ShrinkageExpense,
  BatchWriteOffReason.WriteOff,
  BatchWriteOffReason.Expiry,
];

export const ORDER_FULFILLMENT_SHORTAGE_BATCH_WRITE_OFF_REASONS = [
  BatchWriteOffReason.OrderFulfillmentShortage,
];

export const getBatchWriteOffReasonOptions = (source?: number | null) => {
  switch (source) {
    case BatchWriteOffSource.Manual:
      return MANUAL_BATCH_WRITE_OFF_REASONS;
    case BatchWriteOffSource.OrderFulfillmentShortage:
      return ORDER_FULFILLMENT_SHORTAGE_BATCH_WRITE_OFF_REASONS;
    default:
      return [
        ...MANUAL_BATCH_WRITE_OFF_REASONS,
        ...ORDER_FULFILLMENT_SHORTAGE_BATCH_WRITE_OFF_REASONS,
      ];
  }
};

export const getBatchWriteOffStatusLabel = (status?: number | null) => {
  switch (status) {
    case BatchWriteOffStatus.PendingConfirmation:
      return "batch_write_off_status_pending_confirmation";
    case BatchWriteOffStatus.Confirmed:
      return "batch_write_off_status_confirmed";
    case BatchWriteOffStatus.Reversed:
      return "batch_write_off_status_reversed";
    default:
      return "not_determined";
  }
};

export const getBatchWriteOffStatusColor = (status?: number | null) => {
  switch (status) {
    case BatchWriteOffStatus.PendingConfirmation:
      return "warning";
    case BatchWriteOffStatus.Confirmed:
      return "success";
    case BatchWriteOffStatus.Reversed:
      return "default";
    default:
      return "default";
  }
};

export const getBatchWriteOffSourceLabel = (source?: number | null) => {
  switch (source) {
    case BatchWriteOffSource.Manual:
      return "batch_write_off_source_manual";
    case BatchWriteOffSource.OrderFulfillmentShortage:
      return "batch_write_off_source_order_fulfillment_shortage";
    default:
      return "not_determined";
  }
};

export const getBatchWriteOffSourceColor = (source?: number | null) => {
  switch (source) {
    case BatchWriteOffSource.Manual:
      return "blue";
    case BatchWriteOffSource.OrderFulfillmentShortage:
      return "purple";
    default:
      return "default";
  }
};

export const getBatchWriteOffReasonLabel = (reason?: number | null) => {
  switch (reason) {
    case BatchWriteOffReason.BalanceDiscrepancy:
      return "batch_write_off_reason_balance_discrepancy";
    case BatchWriteOffReason.Waste:
      return "batch_write_off_reason_waste";
    case BatchWriteOffReason.ShrinkageExpense:
      return "batch_write_off_reason_shrinkage_expense";
    case BatchWriteOffReason.WriteOff:
      return "batch_write_off_reason_write_off";
    case BatchWriteOffReason.Expiry:
      return "batch_write_off_reason_expiry";
    case BatchWriteOffReason.OrderFulfillmentShortage:
      return "batch_write_off_reason_order_fulfillment_shortage";
    default:
      return "not_determined";
  }
};
